export default "/wrap-tokens.612a8407ba0e8abefd6c16fa23450b64.svg";